module.exports = __webpack_public_path__ + "static/gift.c6b20133.png";